import React from 'react';
import { Link } from "react-router-dom";
import productDevelopment from "../../assets/images/services/product-development.png";
import cloudDevops from "../../assets/images/services/cloud-devops.png";
import aiDataEngineering from "../../assets/images/services/ai-data-engineering.png";
import itConsulting from "../../assets/images/services/it-consulting.png";

function Services() {
  const services = [
    {
      label: "Build",
      title: "Product Development",
      desc: "Custom software solutions crafted to solve real business challenges and scale with your growth.",
      image: productDevelopment
    },
    {
      label: "Scale",
      title: "Cloud & DevOps",
      desc: "Cloud infrastructure, deployment pipelines, and release practices for reliable delivery.",
      image: cloudDevops
    },
    {
      label: "Learn",
      title: "AI & Data Engineering",
      desc: "Data pipelines, AI workflows, and analytics foundations that support smarter decisions.",
      image: aiDataEngineering
    },
    {
      label: "Guide",
      title: "IT Consulting",
      desc: "Strategic technology guidance and experienced support for your organization's goals.",
      image: itConsulting
    },
  ];

  return (
    <section id="services" className="services">
      <div className="services-header">
        <p className="eyebrow">Services</p>
        <h2>Practical technology support for growing teams</h2>
        <p>
          From idea to delivery, we help teams build useful software, modernize
          operations, and apply AI with clarity.
        </p>
      </div>

      <div className="service-grid">
        {services.map((service) => (
          <article key={service.title} className="service-card">
            <img src={service.image} alt="" className="service-card-image" />
            <div className="service-card-body">
              <span className="service-label">{service.label}</span>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <Link to="/contact" className="service-link">Discuss service</Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Services;
